const FUNCTION_ENDPOINTS = {
  createManualOrder:
    "https://asia-southeast1-mailcinemaotp.cloudfunctions.net/createManualOrder",
  sendOrderMessage:
    "https://asia-southeast1-mailcinemaotp.cloudfunctions.net/sendOrderMessage",
};

const WARMUP_DEDUPE_MS = 2 * 60 * 1000;
const lastWarmupAt = new Map();

export const warmupAdminFunction = (functionName) => {
  if (typeof document !== "undefined" && document.visibilityState === "hidden") {
    return;
  }

  const endpoint = FUNCTION_ENDPOINTS[functionName];
  if (!endpoint) return;

  const now = Date.now();
  if (now - (lastWarmupAt.get(functionName) || 0) < WARMUP_DEDUPE_MS) return;
  lastWarmupAt.set(functionName, now);

  fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ warmup: true }),
    cache: "no-store",
    keepalive: true,
  }).catch((error) => {
    console.debug(`Admin function warm-up skipped (${functionName}):`, error?.message);
  });
};
